export default __webpack_public_path__ + "assets/audio/1-4140197_clip.mp3";